import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const searchPlan = async (body): Promise<[]> => {
  localStorage.setItem("searchInfo", JSON.stringify(body));
  const { data } = await axiosConsumer.post("/search_plan", body);
  return data;
};

export const insertAce2WarrntyItem = async (warranty_id, body): Promise<[]> => {
  const { data } = await axiosConsumer.post(
    `/ace2/warranty/${warranty_id}/warranty_item`,
    body
  );
  return data;
};

export const aceGetplanById = async (warrantyId, custId, claimId = 1) => {
  const { data } = await axiosConsumer.get(
    `/ace/plan/${warrantyId}?customerId=${custId}&claimId=${claimId}`
  );
  return data;
};

export const ace2GetplanById = async (warrantyId: Number | string) => {
  const { data } = await axiosConsumer.get(`/ace2/plan/${warrantyId}`);
  return data;
};
